import React from "react";
import styled from "styled-components";

import Logo from "../assets/Svgs/star_white_48dp.svg";
import { motion } from "framer-motion";

const Section = styled.section`
min-height: 100vh;
	width: 100vw;
	margin: 5rem auto;
	border-top-left-radius: 16px;
	border-top-right-radius: 16px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	background-color: ${(props) => props.theme.nav};
	color: ${(props) => props.theme.text};

	position: relative;
`;

const LogoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	img {
		width: 10vw;
		height: auto;
	}
	h3 {
		font-size: ${(props) => props.theme.fontxxl};
		font-family: "Montserrat";

		@media (max-width: 48em) {
			font-size: ${(props) => props.theme.fontxl};
		}
	}
`;

const FooterComponent = styled(motion.footer)`
	width: 80vw;

	@media (max-width: 48em) {
		width: 90vw;
	}

	ul {
		list-style: none;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		margin: 2rem;
		margin-top: 4rem;
		padding: 0 1rem;
		border-top: 1px solid ${(props) => props.theme.text};
		border-bottom: 1px solid ${(props) => props.theme.text};

		@media (max-width: 48em) {
			justify-content: center;
		}
	}

	li {
		padding: 2rem;
		font-size: ${(props) => props.theme.fontlg};
		text-transform: uppercase;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			transform: scale(1.1);
		}

		@media (max-width: 48em) {
			padding: 1rem;
			font-size: ${(props) => props.theme.fontmd};
		}
	}
`;

const Bottom = styled.div`
	padding: 0.5rem 0;
	margin: 0 4rem;
	font-size: ${(props) => props.theme.fontlg};

	display: flex;
	justify-content: space-between;
	align-items: center;
	a {
		text-decoration: underline;
	}

	@media (max-width: 64em) {
		flex-direction: column;
		justify-content: center;
		width: 100%;
		margin: 0;
		span {
			transform: none !important;
		}
	}

	@media (max-width: 48em) {
		font-size: ${(props) => props.theme.fontmd};
	}

`;

const Footer = () => {

	return (
		<Section>
			<LogoContainer>
				<img
					data-scroll
					data-scroll-speed="2"
					src={Logo}
					alt="Deborah Adeoye"
				/>
				<h3 data-scroll data-scroll-speed="-1">
					Logo...
				</h3>
			</LogoContainer>
			<FooterComponent
				initial={{ y: "-400px" }}
				whileInView={{ y: 0 }}
				viewport={{ once: false }}
				transition={{
					duration: 1.5,
				}}
			>
				<ul>
					<li>
						<a href="https://linkedin.com/in/deborahadeoye" target="_blank" rel="noreferrer">
							LinkedIn
						</a>
					</li>
					<li>
						<a href="https://github.com/dearlydebbie" target="_blank" rel="noreferrer">
							GitHub
						</a>
					</li>
					<li>
						<a href="https://twitter.com/dearlydebbie" target="_blank" rel="noreferrer">
							Twitter
						</a>
					</li>
					<li>
						<a href="mailto:debbieadeoye1@gmail.com" target="_blank" rel="noreferrer">
							Email
						</a>
					</li>
				</ul>
				<Bottom>
					<span
						data-scroll
						data-scroll-speed="2"
						data-scroll-direction="horizontal"
					>
						&copy; {new Date().getFullYear()}. All Rights Reserved.
					</span>
					<span
						data-scroll
						data-scroll-speed="-2"
						data-scroll-direction="horizontal"
					>
						Made with &hearts; by &nbsp;
						<a
							href="https://github.com/dearlydebbie"
							target="_blank"
							rel="noreferrer"
						>
							Deborah
						</a>
					</span>
				</Bottom>
			</FooterComponent>
		</Section>
	);
};

export default Footer;
